// eslint-disable-next-line wix-custom-rules/wixstores-file-names
import {Scope} from '@wix/app-settings-client';
import {I$WWrapper} from '@wix/native-components-infra/dist/es/src/types/types';
import {QueryParamsService} from '@wix/wixstores-client-storefront-sdk';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {CreateControllerFn} from '@wix/yoshi-flow-editor';
import _ from 'lodash';
import {WixQueryParams} from '../../constants';
import {IGalleryControllerConfig} from '../../types/galleryTypes';
import {WishlistStore} from './WishlistStore';

export const WishlistController: CreateControllerFn = (controllerParams) => {
  const siteStore = controllerParams.appData.context.siteStore;
  const {controllerConfig, flowAPI} = controllerParams;
  const {setProps, compId} = controllerConfig;

  let wishlistStore: WishlistStore;
  let config: IGalleryControllerConfig = _.clone(controllerConfig.config);
  let queryParamsService: QueryParamsService;
  let rerenderUrlHeaders: {lang: string; currency: string};

  /* istanbul ignore next: no velo functions to test */
  const exports = () => {
    return {
      //
    };
  };

  const updateConfig = (_$w: I$WWrapper, newConfig: IGalleryControllerConfig) => {
    config = _.clone(newConfig);
    void wishlistStore.updateState(config);
  };

  const updateAppSettings = (_$w: I$WWrapper, updates: {[key: string]: any}) => {
    /* istanbul ignore else */
    if (updates.scope === Scope.COMPONENT && updates.source === 'app-settings') {
      void wishlistStore.updateAppSettings(updates.payload);
    }
  };

  const load = async () => {
    /* istanbul ignore next: cannot test */
    if (wishlistStore) {
      const currentLang = queryParamsService.getQueryParam(WixQueryParams.Lang);
      const currentCurrency = queryParamsService.getQueryParam(WixQueryParams.Currency);
      const {currency, lang} = rerenderUrlHeaders;
      if (currency === currentCurrency && lang === currentLang) {
        return;
      }

      rerenderUrlHeaders = {
        [WixQueryParams.Lang]: currentLang,
        [WixQueryParams.Currency]: currentCurrency,
      };
    }

    wishlistStore = new WishlistStore(
      config,
      setProps,
      siteStore,
      config.externalId,
      compId,
      config.type,
      flowAPI.reportError,
      flowAPI.panoramaClient,
      flowAPI.controllerConfig.wixCodeApi
    );

    await wishlistStore.setInitialState().catch(flowAPI.reportError);
  };

  const init = async () => {
    await siteStore.loadClientConfig();
    controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void load());
    queryParamsService = new QueryParamsService<SiteStore>(siteStore);
    rerenderUrlHeaders = {
      [WixQueryParams.Lang]: queryParamsService.getQueryParam(WixQueryParams.Lang),
      [WixQueryParams.Currency]: queryParamsService.getQueryParam(WixQueryParams.Currency),
    };

    await load();
  };

  return {
    async pageReady() {
      await init();
    },
    load,
    exports,
    updateConfig,
    updateAppSettings,
  };
};
